import * as querystring from 'querystring'
import config from '../../config'

import { getPasscode } from './util'

export const uploadImage = (id, file, replacingImageId = '', longerWidth) => {
  const body = new FormData()
  const query = longerWidth ? `?${querystring.stringify({ longerWidth })}` : ''
  body.append('file', file)
  return fetch(
    config.apiEndpoint + `/portal/${id}/image/${replacingImageId}` + query,
    {
      headers: {
        'X-Portal-Passcode': getPasscode(),
      },
      method: 'POST',
      body,
    },
  ).then(result => {
    if (result.status === 200) return result.json()
    throw Error(result)
  })
}

export const removeImage = (id, imageId) => {
  return fetch(`${config.apiEndpoint}/portal/${id}/image/${imageId}`, {
    headers: {
      'X-Portal-Passcode': getPasscode(),
    },
    method: 'DELETE',
  })
    .then(result => {
      if (result.status === 200) return result.json()
      throw new Error(result)
    })
    .catch(error => {
      throw new Error('Remove Image error \n' + error)
    })
}



// WEBPACK FOOTER //
// ./src/modules/portal-remote/portalImageService.js